import { tipusViaCons } from "./Mapejos";

  export const formatDate = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat(navigator.language, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date); // Format segons el local de l'usuari
  };

  export const formatTime = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  export const formatDateTime = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    const dataFormatada = new Intl.DateTimeFormat(navigator.language, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date); // Format segons el local de l'usuari

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${dataFormatada} ${hours}:${minutes}`;
  };

  /**
 * Formata una adreça en un string llegible.
 * @param {Object} adreca - Objecte amb els camps de l’adreça.
 * @returns {string} Adreça formatada.
 */
  export const formatAddress = (adreca) => {
    if (!adreca) return "—";
  
    const {
      TipusVia,
      NomVia,
      NumVia,
      EscalaVia,
      Pis,
      Porta,
      Poblacio,
      CodiPostal,
    } = adreca;
  
    const tipusViaAbreujat = tipusViaCons[TipusVia] || TipusVia || ""; // Si no hi ha mapeig, agafem l'original
    const viaCombinada = tipusViaAbreujat && NomVia ? `${tipusViaAbreujat} ${NomVia}` : NomVia || tipusViaAbreujat;
    const escala = EscalaVia ? `Esc. ${EscalaVia}` : "";
    const pisPorta =
      Pis || Porta ? `Pis: ${Pis || "—"}${Porta ? `-${Porta}` : ""}` : "";
    const poblacioCodiPostal =
      CodiPostal || Poblacio
        ? `${CodiPostal ? `${CodiPostal}.` : ""} ${Poblacio || ""}`
        : "";
  
    const parts = [
      viaCombinada,
      NumVia ? `nº ${NumVia}` : "",
      escala,
      pisPorta,
      poblacioCodiPostal,
    ];
  
    return parts.filter(Boolean).join(", ");
  };

  export const generateAddress = (adreca) => {
    const viaPrincipal = [adreca.TipusVia, adreca.NomVia].filter(Boolean).join(" ");
    const parts = [
      viaPrincipal,
      adreca.NumVia,
      adreca.EscalaVia ? `Escala ${adreca.EscalaVia}` : "",
      adreca.Pis ? `Pis ${adreca.Pis}` : "",
      adreca.Porta ? `Porta ${adreca.Porta}` : "",
    ];
    return parts.filter(Boolean).join(", ");
  };


  
  export const formatNumero = (value) => {
    if (value === null || value === undefined || isNaN(value)) return "—"; // Gestiona valors invàlids
    return new Intl.NumberFormat("es-ES", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
    }).format(value);
  };


  /**
 * Nom d'Empresa a mostrar a la UI: NomComercial si existeix, sinó Nom.
 * Centralitza aquesta regla perquè no es dupliqui a cada pantalla.
 * @param {Object} empresa - Objecte amb (almenys) Nom i/o NomComercial.
 * @returns {string} Nom visible de l'Empresa.
 */
  export const getNomEmpresaVisible = (empresa) => {
    if (!empresa) return "";
    return empresa.NomComercial?.trim() ? empresa.NomComercial : (empresa.Nom || "");
  };

  /**
   * Nom de persona a llistes: "Cognom1 Cognom2, Nom".
   * Si falta el nom o els cognoms, retorna el que hi hagi sense coma.
   */
  export const formatNomPersona = (persona) => {
    if (!persona) return "";
    const cognoms = [persona.Cognom1, persona.Cognom2].filter(Boolean).join(" ").trim();
    const nom = (persona.Nom || "").trim();
    if (cognoms && nom) return `${cognoms}, ${nom}`;
    return cognoms || nom;
  };

  export const calculMaObra = (preuHora, unitatTemps, quantitat) => {
    // Si no hi ha preu o quantitat, retornem 0
    if (!preuHora || !quantitat) return 0;
  
    // Factors de conversió de la unitat de temps a hores
    const factors = {
      "Minuts": 1 / 60,   // 1 minut = 1/60 d'una hora
      "Hores": 1,         // 1 hora = 1 hora
      "Dies": 8,          // Suposem que un dia té 8 hores laborals
      "Setmanes": 40,     // Suposem que una setmana té 40 hores laborals
      "Mesos": 160        // Suposem que un mes té 160 hores laborals (4 setmanes)
    };
  
    // Agafem el factor correcte segons la unitat de temps, o 1 si no el trobem
    const factor = factors[unitatTemps] || 1;
  
    // Càlcul del preu final
    const preuFinal = preuHora * parseFloat(quantitat) * factor;
  
    // Arrodonim a 2 decimals
    return parseFloat(preuFinal.toFixed(2));
  };
  